<template>
  <div class="vue timparty-iw-slider iw-slider bg-dark text-white" :class="[contests.length > 0 ? 'py-4' : '']">
    <LoaderOverlay v-if="loading"/>

    <div class="contests-slider-container" v-if="contests.length > 1">
      <div class="contests-slider-controls" v-if="contests.length > 2">
        <div>
          <a href="#" @click.prevent="sliderGoto('prev')"><img :src="themePath('images/arrow-left-white-on-blue.png')"
                                                               class="d-block"></a>
          <a href="#" @click.prevent="sliderGoto()"><img :src="themePath('images/arrow-right-white-on-blue.png')"
                                                         class="d-block"></a>
        </div>
      </div>
      <div :id="slider_id" class="contests-slider" v-if="contests">
        <div :class="'slide-content' + (contests.length == 1 ? ' single' : '' )" v-for="contest in contests"
             v-bind:key="contest">


          <instant-win-card :api-url="api_url" :contest-type="contestType" :contest="contest"></instant-win-card>
        </div>
      </div>


    </div>
    <div class="band-contest-container" v-else-if="contests.length == 1">
      <band-contest :contest="contests[0]"></band-contest>
    </div>

    <div class="text-center py-5">
      <a v-if="catalogUrl" @click='aaEvent("click", { form: { click: "Scopri concorsi" } })' :href="catalogUrl"
         class="btn btn-lg btn-white text-uppercase cta-generic">{{ __('Scopri tutti i concorsi') }}</a>
    </div>


  </div>
</template>

<script>

/* eslint-disable */

import TimPartyMixin  from '../mixins/TimPartyMixin';
import LoaderOverlay  from './LoaderOverlay.vue'
import InstantWinCard from './InstantWinCard.vue'
import BandContest    from './BandContest.vue'
import $              from 'jquery';
import 'slick-carousel';


export default {
  name: 'InstantWinSlider',
  mixins: [TimPartyMixin],
  components: {
    LoaderOverlay,
    InstantWinCard,
    BandContest
  },
  props: {

    apiUrl: {
      type: String,
      required: true
    },
    catalogUrl: {
      type: String,
      required: false
    },
    excludedCodes: {
      type: Array,
      required: false
    },
    contestType: {
      type: String,
      required: false
    }

  },
  data: function () {
    return {
      contests: [],
      now: null,
      slider_id: 'contests-slider'
    };
  },
  mounted: function () {
    this.setApiUrl(this.apiUrl);

    this.now = Math.floor(new Date().getTime() / 1000);

    this.slider_id = this.slider_id + '-' + this.getRandomString(8);

    if (this.access_token) {
      this.getContests();
    }
  },
  methods: {
    activateSlider: function () {
      var self = this;

      this.$nextTick(function () {
        $('#' + this.slider_id).slick({
          dots: false,
          infinite: false,
          arrows: false,
          slidesToShow: self.contests.length > 1 ? 2.2 : 1,
          slidesToScroll: 1,
          autoplay: false,
          responsive: [

            {
              breakpoint: 991,
              settings: {
                slidesToShow: self.contests.length > 1 ? 2.1 : 1,
                slidesToScroll: 1,
                dots: true
                //
              }
            },
            {
              breakpoint: 520,
              settings: {
                slidesToShow: self.contests.length > 1 ? 1.1 : 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false
              }
            }
          ]
        });
      });
    },

    getContests: function () {

      var self = this,
          payload_action;

      if (self.contestType == 'inactive') {
        payload_action = 'getAllInactive';
      }
      else {
        payload_action = 'getAllActive';
      }

      var payload = {
        action: payload_action,
        access_token: this.access_token
      };

      self.loading = true;
      this.callApi(payload, function (response) {


        self.loading = false;

        if (response.data != undefined) {
          self.contests = response.data;

          if (self.excludedCodes) {
            self.contests = _.filter(self.contests, function (item) {

              return (self.excludedCodes.indexOf(item.code) == -1);

            });
          }


          // keep only the contests with a url > node
          self.contests = _.filter(self.contests, function (item) {

            return (item.extra != undefined && item.extra.url)

          });

          if (self.contestType == 'inactive') {
            var reordered = self.contests.map((item) => {
              item.order = (item.endDate < self.now) ? (item.endDate * 2) : item.endDate;
              return item;
            }).sort(function (a, b) {
              return b.order - a.order;
            });
          }
          else {
            var reordered = self.contests.map((item) => {
              item.order = (item.startDate < self.now) ? (item.startDate * 2) : item.startDate;
              return item;
            }).sort(function (a, b) {
              return b.order - a.order;
            });
          }

          self.contests = reordered;

          if (self.contests.length > 1) {
            self.activateSlider();
          }
        }

      });

    },

    sliderGoto: function (dir) {
      if (dir == 'prev') {
        $('#' + this.slider_id).slick('slickPrev');
      }
      else {
        $('#' + this.slider_id).slick('slickNext');
      }
    }
  },
  computed: {},
  watch: {
    access_token: function (new_val, old_val) {
      this.getContests();
    }
  }
}
</script>


